<template>
  <div id="todo-app" class="vs-con-loading__container">
    <vs-row class="m-0 p-0" vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
      <vs-col class="m-0 p-0" vs-type="flex" vs-justify="center" vs-align="center" vs-w="9">
        <!-- <Todo /> -->
        <Container></Container>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import Container from "./components/container.vue";
import moduleTodo from "./store/moduleTodo.js";

export default {
  components: { Container },
  async created() {
    try {
      this.$store.registerModule("transer", moduleTodo);
      this.setSidebarWidth();

      // Fetch Tasks
      await this.$store.dispatch("transer/fetchTasks", this.$store.state.user.companyID);

      this.$store.dispatch("transer/fetchTags");
    } catch (error) {
    } finally {
      this.$vs.loading.close("#todo-app > .con-vs-loading");
    }
  },
  beforeUpdate() {
    this.currFilter = this.$route.params.filter;
  },
  beforeDestroy() {
    this.$store.unregisterModule("transer");
  },
  mounted() {
    this.$store.dispatch("transer/setTodoSearchQuery", "");
  }
};
</script>

<style lang="scss" scoped></style>
